export const getOrderAnalyst = (data, currentUser) => {
    const assignedId = Number(data.AssignedToId ?? data.AssignedToID ?? 0);
    return assignedId > 0
        ? { Key: assignedId, Value: data.AssignedTo || '' }
        : { Key: Number(currentUser.id) || 0, Value: [currentUser.lastName, currentUser.firstName].filter(Boolean).join(', ') };
};

export const getOrderAnalystOptions = (options = [], id, name) => {
    const normalized = options.map(option => ({ ...option, Key: Number(option.Key) }));
    if (Number(id) > 0 && name && !normalized.some(option => option.Key === Number(id))) {
        return [{ Key: Number(id), Value: name }, ...normalized];
    }
    return normalized;
};
